export const filterConfigText = (value) => {
    if (Object.keys(configTranslations).filter(item => item == value).length == 0) {
        return;
    }
    return `${headerTypes[configTranslations[value].type]} ${configTranslations[value].isButton ? 'Botão' : ''} 
    ${configTranslations[value].name}`
}

const configTranslations = {
    acompanhamentos: {
        name: 'Acompanhamentos',
        type: 'cidade',
    },
    agenteTerritorial: {
        isButton: true,
        name: 'Agente Territorial',
        type: 'cidade',
    },
    analisarAprovadas: {
        isButton: true,
        name: 'Analisar\tAprovadas',
        type: 'evidencia',
    },
    analisarEvidenciadas: {
        isButton: true,
        name: 'Analisar Evidenciadas',
        type: 'evidencia',
    },
    analisarRejeitadas: {
        isButton: true,
        name: 'Analisar Rejeitadas',
        type: 'evidencia',
    },
    analisarRelatorios: {
        name: 'Analisar Relatorios',
        type: 'menu',
    },
    analisarRelatoriosAdministrativos: {
        name: 'Analisar Relatorios Administrativos',
        type: 'menu',
    },
    andamento: {
        name: 'Andamento',
        type: 'cidade',
    },
    cadastroEmLote: {
        isButton: true,
        name: 'Cadastro em Lote',
        type: 'cidade',
    },
    calendario: {
        name: 'Calendário',
        type: 'cidade',
    },
    configuracao: {
        name: 'Configuração',
        type: 'menu',
    },
    dashboardAdministrativo: {
        name: 'Dashboard Administrativo',
        type: 'menu',
    },
    editarMunicipio: {
        isButton: true,
        name: 'Editar Município',
        type: 'cidade',
    },
    eixos: {
        name: 'Eixos',
        type: 'menu',
    },
    encontros: {
        name: 'Encontros',
        type: 'menu',
    },
    enviarAprovadas: {
        isButton: true,
        name: 'Enviar Aprovadas',
        type: 'evidencia',
    },
    enviarEvidenciadas: {
        isButton: true,
        name: 'Enviar Evidenciadas',
        type: 'evidencia',
    },
    enviarRejeitadas: {
        isButton: true,
        name: 'Enviar Rejeitadas',
        type: 'evidencia',
    },
    enviarRespondidas: {
        isButton: true,
        name: 'Enviar Respondidas',
        type: 'evidencia',
    },
    eventos: {
        name: 'Eventos',
        type: 'menu',
    },
    evidencias: {
        name: 'Evidências',
        type: 'cidade',
    },
    finalizarAcompanhamento: {
        isButton: true,
        name: 'Finalizar Acompanhamento',
        type: 'cidade',
    },
    grupo: {
        name: 'Grupos',
        type: 'menu',
    },
    grupos: {
        name: 'Grupos',
        type: 'cidade',
    },
    medalhas: {
        name: 'Medalhas',
        type: 'menu',
    },
    meusProcessosPagamentos: {
        name: 'Meus Processos de Pagamentos',
        type: 'menu',
    },
    novoAcompanhamento: {
        isButton: true,
        name: 'Novo Acompanhamento',
        type: 'cidade',
    },
    novoEvento: {
        isButton: true,
        name: 'Novo Evento',
        type: 'calendario',
    },
    novoGrupo: {
        isButton: true,
        name: 'Novo Grupo',
        type: 'grupo',
    },
    novoRelatorio: {
        isButton: true,
        name: 'Novo Relatório',
        type: 'relatorio',
    },
    novoRelatorioAdministrativo: {
        isButton: true,
        name: 'Novo Relatório Admin.',
        type: 'relatorioAdmin',
    },
    pacotes: {
        name: 'Pacotes',
        type: 'menu',
    },
    perguntas: {
        name: 'Perguntas',
        type: 'menu',
    },
    processosPagamento: {
        name: 'Processos de Pagamento',
        type: 'menu',
    },
    projetoseSolucoes: {
        name: 'Projetos e Soluções',
        type: 'menu',
    },
    realizarDiagnostico: {
        name: 'Realizar Diagnóstico',
        type: 'cidade',
    },
    relatorioAdministrativo: {
        name: 'Relatório Administrativo',
        type: 'cidade',
    },
    relatorioGlobal: {
        isButton: true,
        name: 'Relatório Global',
        type: 'dashboard',
    },
    relatorioMensal: {
        isButton: true,
        name: 'Relatório Mensal',
        type: 'cidade',
    },
    relatorios: {
        name: 'Relatórios',
        type: 'cidade',
    },
    resumoMunicipio: {
        isButton: true,
        name: 'Resumo do Município',
        type: 'cidade',
    },
    sala: {
        name: 'Sala',
        type: 'cidade',
    },
    salaEmpreendedor: {
        name: 'Sala do Empreendedor',
        type: 'menu',
    },
    salvarMunicipio: {
        isButton: true,
        name: 'Editar Municipio --> Salvar',
        type: 'cidade',
    },
    salvarMunicipioVigente: {
        isButton: true,
        name: 'Editar Municipio --> Salvar (Municipios Vigente)',
        type: 'cidade',
    },
    temas: {
        name: 'Temas',
        type: 'menu',
    },
    termoReferencia: {
        name: 'Termo de Referência',
        type: 'cidade',
    },
    unidadesRegionais: {
        name: 'Unidades Regionais',
        type: 'menu',
    },
    usuarios: {
        name: 'Usuarios',
        type: 'menu',
    },
    visualizarAprovadas: {
        isButton: true,
        name: 'Visualizar Aprovadas',
        type: 'evidencia',
    },
    visualizarEvidenciadas: {
        isButton: true,
        name: 'Visualizar Evidenciadas',
        type: 'evidencia',
    },
    visualizarLogo: {
        name: 'Visualizar Logo no Sistema',
        type: 'sistema',
    },
    visualizarPontosMedalha: {
        name: 'Visualizar Pontos e Medalhas',
        type: 'sistema',
    },
    visualizarRejeitadas: {
        isButton: true,
        name: 'Visualizar Rejeitadas',
        type: 'evidencia',
    },
}

const headerTypes = {
    calendario: 'Municipio --> Cidade --> Calendário -->',
    cidade: 'Municipio --> Cidade -->',
    dashboard: 'Menu --> Dashboard Admin. -->',
    evidencia: 'Municipio --> Cidade --> Evidência -->',
    grupo: 'Municipio -- > Cidade-- > Grupos -->',
    menu: 'Menu -->',
    relatorio: 'Municipio -- > Cidade --> Relatório -->',
    relatorioAdmin: 'Municipio -- > Cidade --> Relatório Admin.-->',
    sistema: 'Sistema -->',
}

export const initialConfig = {
    acompanhamentos: false,
    agenteTerritorial: false,
    analisarAprovadas: false,
    analisarEvidenciadas: false,
    analisarRejeitadas: false,
    analisarRelatorios: false,
    analisarRelatoriosAdministrativos: false,
    andamento: false,
    cadastroEmLote: false,
    calendario: false,
    configuracao: false,
    dashboardAdministrativo: false,
    editarMunicipio: false,
    eixos: false,
    encontros: false,
    enviarAprovadas: false,
    enviarEvidenciadas: false,
    enviarRejeitadas: false,
    enviarRespondidas: false,
    eventos: false,
    evidencias: false,
    finalizarAcompanhamento: false,
    grupo: false,
    grupos: false,
    medalhas: false,
    meusProcessosPagamentos: false,
    novoAcompanhamento: false,
    novoEvento: false,
    novoGrupo: false,
    novoRelatorio: false,
    novoRelatorioAdministrativo: false,
    pacotes: false,
    perguntas: false,
    processosPagamento: false,
    projetoseSolucoes: false,
    realizarDiagnostico: false,
    relatorioAdministrativo: false,
    relatorioGlobal: false,
    relatorioMensal: false,
    relatorios: false,
    resumoMunicipio: false,
    sala: false,
    salaEmpreendedor: false,
    salvarMunicipio: true,
    salvarMunicipioVigente: false,
    temas: false,
    termoReferencia: false,
    unidadesRegionais: false,
    usuarios: false,
    visualizarAprovadas: false,
    visualizarEvidenciadas: false,
    visualizarLogo: true,
    visualizarPontosMedalha: true,
    visualizarRejeitadas: false,
}